import Icon from '../../../../primitives/icon/index';

import styles from './FairPlayWithTagLine.module.css';

export const FairPlayWithTagLine = () => {
  return (
    <div className={styles.fairPlayWithTagLine}>
      <span className={styles.tagLine}>Proudly part of:</span>
      <Icon className={styles.fairPlayLogo} icon="FairPlayLogo" />
    </div>
  );
};
